﻿window.cObjetCgvMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "CGV"; }
    this.mGetAttributBase = function () { return "les " }
    this.mGetNewLib = function () { return "Nouvelle CGV"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = "CGV du " + objet.data.dcr.toDDMMMAA() }
        else {
            txt = "CGV"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-file-contract' class='cgv'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        Me.objet.bddRef.mAjaxCall({ command: "copycgvnewname", id_cgv: objet.data.id_cgv },
            function (data) {
                var $EleDoc = $("<iframe style='height:100%;width:100%;border-radius:3px;box-sizing:border-box;border:none;' src='" + data.urlcgv + "'/>")
                $EleDoc.appendTo(contentElement);
                //$EleDoc.on("load", function () { jauge.mHide() })
            })
    }

    this.mShowPopup = function (optionPopup) {
        if (typeof optionPopup == 'undefined' || optionPopup == null) optionPopup = {}
        optionPopup.disableScroll = true;
        return objet.mShowPopupInterne(optionPopup)
    }

    this.mDownLoadNewCgv = function (dataSociete, funcOk) {
        $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
            bddCtrl: Me.objet.bddRef,
            multiple: false,
            accept: ".pdf",
            onValide: function (lstUrlFile) {
                if (lstUrlFile.length > 0) {
                    jaugeDemarrage.mShow()
                    Me.objet.bddRef.mAjaxCall({ command: "savenewcgv", urlpathtemp: lstUrlFile[0], id_societe: dataSociete.id_societe }, function (data) {
                        var dataCgv = Me.objet.bddRef.getObjet("cgv",  data.bddadd.cgv[0].id_cgv).data
                        jaugeDemarrage.mHide(0)
                        funcOk(dataCgv)
                    })
                    //var dataCgv = objet.mGetNewData()
                    //dataCgv.id_societe = dataSociete.id_societe
                    //dataCgv.url = lstUrlFile[0]
                    //dataCgv.pathNameFile = lstUrlFile[0]
                    //Me.objet.bddRef.getObjet(dataCgv).mSave(function (data) {
                    //    delete dataCgv.pathNameFile
                    //    funcOk(dataCgv)
                    //})
                }
            }
        }).dxCtrlFileUploaderPopup("instance")
    }

    this.mGetLienCgv = function () {
        return "~/Fichier/" + Me._nomBase + "/bdd/cgv/" + objet.data.id_cgv + ".pdf"
    }

}